import React from 'react'
import '../index.css'
import { Box, Button } from '@mui/material'
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import authService from '../services/auth_service';


const Sidebar = () => {
    const [activeButton, setActiveButton] = useState(0);
    const navigate = useNavigate();
  
    const handleButtonClick = (buttonName) => {
      setActiveButton(buttonName);
    };

    const handleManajemenUserClick = () => {
      // TODO benerin maybe
      navigate('../dashboard/management/user');
      setActiveButton('Manajemen User');
    };

    const handleKelasClick = () => {
      navigate("../dashboard/management/kelas")
      setActiveButton("Kelas");
    };

    const handleBookingKelasClick = () => {
      setActiveButton("Booking Kelas");
      navigate('../dashboard/management/booking')
      setActiveButton('Booking Kelas')
      // TODO navigate to Booking Kelas
    };

    const handleProgramMakananClick = () => {
      navigate("../dashboard/management/diet");
      setActiveButton("Manajemen Diet");
    };    

    const handlePersonalTrainerClick = () => {
      navigate('../dashboard/management/trainer');
      setActiveButton("Personal Trainer");
      // TODO navigate to personal trainer
    };

    const handleFeedbackClick = () => {
      navigate('../dashboard/management/feedback');
      setActiveButton("Feedback");
    };


   const [userRole, setUserRole] = useState(null);

   useEffect(() => {
     const userData = authService.getUserDataFromLocalStorage();
     if (userData && userData.role) {
       setUserRole(userData.role);
       console.log(userRole);
//        if (userData.role === 2) {
//          navigate('/dashboard/management/feedback');
//        } else if (userData.role === 2) {
//          // Redirect to the "ManagementFeedbackPage"
//          navigate('/dashboard/management/feedback');
//        } else {
//          // Show unauthorized message
//          console.log("Unauthorized access");
//        }
     }
   }, []);


   console.log(userRole);

    return (
      <Box sx={{backgroundColor: '#1C1C1E', color: 'white', width: 250, height: '100vh' }}>
        {userRole === 5 && (
        <div>
          <Button
            sx={{
              color: activeButton === 'Manajemen User' ? 'primary.main' : 'inherit',
              textTransform: 'none',
              fontFamily: 'Titillium Web',
              fontWeight: '600', // semi-bold
              fontSize: '18px',
              justifyContent: 'flex-start',
              paddingLeft: 4,
              bgcolor: activeButton === 'Manajemen User' ? '#46464A' : 'inherit',
            }}
            onClick={handleManajemenUserClick}
            fullWidth
          >
            Manajemen User
          </Button>

          <Button
            sx={{
              color: activeButton === 'Kelas' ? 'primary.main' : 'inherit',
              textTransform: 'none',
              fontFamily: 'Titillium Web',
              fontWeight: '600', // semi-bold
              fontSize: '18px',
              justifyContent: 'flex-start',
              paddingLeft: 4,
              bgcolor: activeButton === 'Kelas' ? '#46464A' : 'inherit',
            }}
            onClick={() => handleKelasClick()}
            fullWidth
          >
            Manajemen Kelas
          </Button>

          <Button
            sx={{
              color: activeButton === 'Booking Kelas' ? 'primary.main' : 'inherit',
              textTransform: 'none',
              fontFamily: 'Titillium Web',
              fontWeight: '600', // semi-bold
              fontSize: '18px',
              justifyContent: 'flex-start',
              paddingLeft: 4,
              bgcolor: activeButton === 'Booking Kelas' ? '#46464A' : 'inherit',
            }}
            onClick={handleBookingKelasClick}
            fullWidth
          >
            Booking Kelas
          </Button>

          <Button
            sx={{
              color: activeButton === 'Program Makanan' ? 'primary.main' : 'inherit',
              textTransform: 'none',
              fontFamily: 'Titillium Web',
              fontWeight: '600', // semi-bold
              fontSize: '18px',
              justifyContent: 'flex-start',
              paddingLeft: 4,
              bgcolor: activeButton === 'Program Makanan' ? '#46464A' : 'inherit',
            }}
            onClick={handleProgramMakananClick}
            fullWidth
          >
            Program Makanan
          </Button>

          <Button
            sx={{
              color: activeButton === 'Personal Trainer' ? 'primary.main' : 'inherit',
              textTransform: 'none',
              fontFamily: 'Titillium Web',
              fontWeight: '600', // semi-bold
              fontSize: '18px',
              justifyContent: 'flex-start',
              paddingLeft: 4,
              bgcolor: activeButton === 'Personal Trainer' ? '#46464A' : 'inherit',
            }}
            onClick={() => handlePersonalTrainerClick('Personal Trainer')}
            fullWidth
          >
            Personal Trainer
          </Button>
          </div>
        )}

        {userRole === 2 && (
        <div>
          <Button
            sx={{
              color: activeButton === 'Feedback' ? 'primary.main' : 'inherit',
              textTransform: 'none',
              fontFamily: 'Titillium Web',
              fontWeight: '600', // semi-bold
              fontSize: '18px',
              justifyContent: 'flex-start',
              paddingLeft: 4,
              bgcolor: activeButton === 'Feedback' ? '#46464A' : 'inherit',
            }}
            onClick={handleFeedbackClick}
            fullWidth
          >
            Manajemen Feedback
          </Button>
        </div>
        )}
        </Box>
      );
  };
  
  export default Sidebar;